import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types.ts';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

/** false si el build no recibió URL/clave: la UI muestra un aviso de configuración. */
export const supabaseConfigured = Boolean(url && key && !url.includes('<') && !key.includes('<'));

// La clave publicable es pública por diseño; la seguridad la dan RLS y las RPCs.
export const supabase = createClient<Database>(url ?? 'http://supabase.invalid', key ?? 'sin-configurar', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'servicioos-auth',
  },
});
